import React from 'react';

import { useLinkTextToAvoidInJobSearchesState, useLinkTextToAvoidInJobSearchesActions } from './LinkTextToAvoidInJobSearchesContext';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import DeleteLinkTextForm from './DeleteLinkTextForm';

const DeleteLinkTextModal = () => {
  const state = useLinkTextToAvoidInJobSearchesState();
  const { closeDeleteLinkTextModal } = useLinkTextToAvoidInJobSearchesActions();

  if (!state?.deleteLinkTextModalIsOpen) {
    return null;
  }

  return (
    <StandardModal
      isOpen={state.deleteLinkTextModalIsOpen}
      onRequestClose={closeDeleteLinkTextModal}
      title="Delete Link Text"
    >
      <DeleteLinkTextForm />
    </StandardModal>
  );
};

export default DeleteLinkTextModal;
